import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { environment } from '../environments/environment';
import { PageNotFoundComponent } from "app/page-not-found.component";
import { RedirectionGuard } from "app/redirection-guard.service";
import { PageNotWorkingComponent } from "app/page-not-working.component";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    children: [],
    canActivate: [RedirectionGuard],
  },
  { path: 'pagenotworking', component: PageNotWorkingComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  declarations: [
    PageNotFoundComponent,
    PageNotWorkingComponent
  ],
  imports: [
    RouterModule.forRoot(routes, { enableTracing: !environment.production })
  ],
  exports: [
    RouterModule
  ],
  providers: [
    RedirectionGuard
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/app.routing.ts